var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rest-page',{attrs:{"fetch-endpoint":_vm.fetchEndpoint,"layout":"tabbed"}},[(_vm.model)?[_c('page-header-new',{attrs:{"breadcrumbs":_vm.breadcrumbs,"title":_vm.model.title}}),_vm._v(" "),_c('page-tabs',{attrs:{"tabs":_vm.tabs}})]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49a08d4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/audiences/pages/SharedSegmentPage.vue
// module id = null
// module chunks = 